import { Link, router } from "@inertiajs/react"
import { ChevronLeft, ChevronRight } from "lucide-react"

export function Pagination({ pagination, baseUrl = "/collective" }) {
  const { currentPage, totalPages, totalCount, from, to, preservedQuery = {} } = pagination

  if (totalPages <= 1) return null

  // Build hrefs purely from props so SSR and client produce identical links
  // and filter params survive a pre-hydration click.
  const getPageUrl = (page) => {
    const params = new URLSearchParams(preservedQuery)
    if (page > 1) params.set("page", page)
    const qs = params.toString()
    return qs ? `${baseUrl}?${qs}` : baseUrl
  }

  // Generate page numbers to show
  const getPageNumbers = () => {
    const pages = []
    const showPages = 5
    let start = Math.max(1, currentPage - Math.floor(showPages / 2))
    let end = Math.min(totalPages, start + showPages - 1)

    // Adjust start if we're near the end
    if (end - start < showPages - 1) {
      start = Math.max(1, end - showPages + 1)
    }

    for (let i = start; i <= end; i++) {
      pages.push(i)
    }
    return pages
  }

  return (
    <div className="flex flex-col items-center gap-4">
      {/* Info */}
      <p className="text-sm text-zinc-500">
        Showing {from} - {to} of {totalCount} articles
      </p>

      {/* Navigation */}
      <nav className="flex items-center gap-2">
        {/* Previous */}
        {currentPage > 1 ? (
          <Link
            href={getPageUrl(currentPage - 1)}
            className="p-2 rounded border border-zinc-200 hover:bg-zinc-50 text-zinc-600 hover:text-kf-red transition-colors"
          >
            <ChevronLeft className="w-5 h-5" />
          </Link>
        ) : (
          <span className="p-2 rounded border border-zinc-100 text-zinc-300 cursor-not-allowed">
            <ChevronLeft className="w-5 h-5" />
          </span>
        )}

        {/* Page numbers */}
        {getPageNumbers().map((page) => (
          <Link
            key={page}
            href={getPageUrl(page)}
            className={`px-4 py-2 rounded text-sm font-medium transition-colors ${
              page === currentPage
                ? "bg-kf-gradient text-white"
                : "border border-zinc-200 hover:bg-zinc-50 text-zinc-600 hover:text-kf-red"
            }`}
          >
            {page}
          </Link>
        ))}

        {/* Next */}
        {currentPage < totalPages ? (
          <Link
            href={getPageUrl(currentPage + 1)}
            className="p-2 rounded border border-zinc-200 hover:bg-zinc-50 text-zinc-600 hover:text-kf-red transition-colors"
          >
            <ChevronRight className="w-5 h-5" />
          </Link>
        ) : (
          <span className="p-2 rounded border border-zinc-100 text-zinc-300 cursor-not-allowed">
            <ChevronRight className="w-5 h-5" />
          </span>
        )}
      </nav>
    </div>
  )
}
